
import { SharingNetworks } from "@models/enums";
import { ciTrackingService } from "@services/ci-tracking.service";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "AdvisorContactCTA",
})
export default class extends Vue {
  @Prop({ default: false }) public showMessaging!: boolean;
  @Prop({ default: false }) public showContact!: boolean;
  @Prop({ required: true }) public advisor!: UsersV2.User;

  public sharingNetworks = [
    SharingNetworks.CustomEmail,
    SharingNetworks.CustomMessaging,
    SharingNetworks.LinkedIn,
    SharingNetworks.Twitter,
    SharingNetworks.Facebook,
  ];

  public get componentTitle(): string {
    return this.$t("ui.views.users.show.contact_component.description", {
      advisor_name: `${this.advisor.firstname} ${this.advisor.lastname}`,
    }) as string;
  }

  public get sharing(): Indexable {
    return {
      trackingTarget: {
        name: "UserProfileAdvisor",
        identifier: this.advisor.id.toString(),
      },
      url: location.href,
    };
  }

  public handleOpenModal(): void {
    ciTrackingService.trackClick("ButtonSendConsultationRequest", this.advisor.id.toString(), "UserProfileAdvisor");
    this.$emit("show-contact-form");
  }
}
